<button
  type="button"
  class="inline-flex items-center justify-center gap-3 px-6 py-3 bg-white text-gray-700 text-[15px] font-semibold rounded-lg border border-gray-300 transition-all duration-200 hover:bg-gray-50 hover:border-gray-400 active:bg-gray-100 disabled:opacity-60 disabled:cursor-not-allowed h-[48px]"
  [class.w-full]="fullWidth"
  [disabled]="isLoading()"
  (click)="handleMicrosoftLogin()"
  style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
>
  <!-- Microsoft Logo -->
  @if (!isLoading()) {
    <svg
      class="w-[20px] h-[20px] flex-shrink-0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23 23"
    >
      <path fill="#f3f3f3" d="M0 0h23v23H0z" />
      <path fill="#f35325" d="M1 1h10v10H1z" />
      <path fill="#81bc06" d="M12 1h10v10H12z" />
      <path fill="#05a6f0" d="M1 12h10v10H1z" />
      <path fill="#ffba08" d="M12 12h10v10H12z" />
    </svg>
  }

  <!-- Loading Spinner -->
  @if (isLoading()) {
    <span
      class="spinner w-[18px] h-[18px] border-2 border-gray-200 border-t-gray-700 rounded-full flex-shrink-0"
    ></span>
  }

  <!-- Label -->
  <p class="text-sm font-medium">
    {{ isLoading() ? 'Autenticando...' : label }}
  </p>
</button>
